import {lazy} from "react";

export const ActiveListSingleVoyagesLazy = lazy(() => import('./ActiveListSingleVoyages'))